export default __webpack_public_path__ + "static/media/doj.4bea919f.svg";